export enum NodeType {
	TAG = 'TAG',
	FILE = 'FILE',
	WEBSITE = 'WEBSITE',
	NOTE = 'NOTE',
}

export const nodeTypeIcon: Record<NodeType, string> = {
	TAG: 'icon-tag',
	FILE: 'icon-document',
	WEBSITE: 'icon-website',
	NOTE: 'icon-note',
};

export const nodeTypeColor: Record<NodeType, string> = {
	TAG: 'var(--color-node-tag)',
	FILE: 'var(--color-node-file)',
	WEBSITE: 'var(--color-node-website)',
	NOTE: 'var(--color-node-note)',
};

export const nodeTypeColorRGB: Record<NodeType, string> = {
	TAG: 'var(--color-node-tag-rgb)',
	FILE: 'var(--color-node-file-rgb)',
	WEBSITE: 'var(--color-node-website-rgb)',
	NOTE: 'var(--color-node-note-rgb)',
};
